import React, { useState } from 'react';
import './index.css';

const About = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    name: "Starrr",
    avatar: "https://tu.tuhemmei.com/zb_users/upload/2023/06/20230613168661723",
    bio: "这个人很神秘，什么也没留下。",
    email: "Starrr@gmail.com",
    techStack: "暂无",
    hobbies: "暂无",
    github: "#",
    website: "#"
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    setIsEditing(false);
    // 这里可以添加保存到后端的逻辑
  };

  return (
    <div className="about">
      <div className="profile-card">
        <div className="avatar-section">
          <img src={profile.avatar} alt="Starrr" className="avatar" />
          <h2>{profile.name}</h2>
          <p className="purple-star">★ 星空下的探索者 ★</p>
        </div>

        {isEditing ? (
          <div className="edit-form">
            <h3>编辑个人信息</h3>
            <label>头像 URL</label>
            <input name="avatar" value={profile.avatar} onChange={handleChange} />

            <label>姓名</label>
            <input name="name" value={profile.name} onChange={handleChange} />

            <label>个人简介</label>
            <textarea name="bio" value={profile.bio} onChange={handleChange} />

            <label>联系邮箱</label>
            <input name="email" value={profile.email} onChange={handleChange} />

            <label>技术栈</label>
            <input name="techStack" value={profile.techStack} onChange={handleChange} />

            <label>兴趣爱好</label>
            <input name="hobbies" value={profile.hobbies} onChange={handleChange} />

            <div className="form-actions">
              <button className="btn-cancel" onClick={() => setIsEditing(false)}>取消</button>
              <button className="btn-purple" onClick={handleSave}>确定</button>
            </div>
          </div>
        ) : (
          <div className="profile-info">
            <p><strong>个人简介:</strong> {profile.bio}</p>
            <p><strong>联系邮箱:</strong> {profile.email}</p>
            <p><strong>技术栈:</strong> {profile.techStack}</p>
            <p><strong>兴趣爱好:</strong> {profile.hobbies}</p>
            <p><strong>GitHub:</strong> <a href={profile.github} target="_blank" rel="noreferrer">点击访问</a></p>
            <button className="btn-purple edit-btn" onClick={() => setIsEditing(true)}>
              编辑个人信息
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default About;